import MuiRadioGroup from '@mui/material/RadioGroup'
import type { RadioGroupProps } from './RadioGroup.types'
import * as S from './RadioGroup.styles'
import InputLabel from '../InputLabel'
import FormHelperText from '../FormHelperText'
import Radio from '../Radio'
import useGuideText from '../../hooks/useGuideText'

const RadioGroup = <T extends string = string>({
  items = [],
  label: labelProp,
  hideLabel = false,
  helperText: helperTextProp,
  hideHelperText = false,
  disabled = false,
  error,
  row = true,
  ...props
}: RadioGroupProps<T>) => {
  const { helperText, label } = useGuideText({
    helperText: helperTextProp,
    hideHelperText,
    label: labelProp,
    hideLabel,
  })

  return (
    <S.FormControl error={error}>
      {label && <InputLabel shrink>{label}</InputLabel>}
      <MuiRadioGroup row={row} {...props}>
        {items.map((radioProps, index) => (
          <Radio disabled={disabled} key={radioProps.value ?? index} {...radioProps} />
        ))}
      </MuiRadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </S.FormControl>
  )
}

export default RadioGroup
